/* DSL a11y toggle handler */
(function(){
  var KEY = "dsl_a11y";
  function load(){ try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch(e){ return {}; } }
  function save(s){ try { localStorage.setItem(KEY, JSON.stringify(s)); } catch(e){} }
  function apply(s){
    document.body.removeAttribute("data-a11y-aaa");
    document.body.removeAttribute("data-a11y-text-lg");
    document.body.removeAttribute("data-a11y-focus-bold");
    if (s["aaa"]) document.body.setAttribute("data-a11y-aaa", "1");
    if (s["text-lg"]) document.body.setAttribute("data-a11y-text-lg", "1");
    if (s["focus-bold"]) document.body.setAttribute("data-a11y-focus-bold", "1");
    if (s["reduce-motion"]) document.body.style.setProperty("--a11y-motion", "0.001ms");
    else document.body.style.removeProperty("--a11y-motion");
  }
  apply(load());
  document.addEventListener("click", function(e){
    if (e.target.matches("[data-a11y-open]")) document.querySelector("[data-a11y-overlay]").hidden = false;
    if (e.target.matches("[data-a11y-close]")) document.querySelector("[data-a11y-overlay]").hidden = true;
    if (e.target.matches("[data-a11y-reset]")) { save({}); apply({}); document.querySelectorAll("[data-a11y]").forEach(function(c){c.checked=false;}); }
  });
  document.addEventListener("change", function(e){
    if (!e.target.matches("[data-a11y]")) return;
    var s = load(); s[e.target.dataset.a11y] = e.target.checked; save(s); apply(s);
    if (window.DSL_AB) window.DSL_AB.track("a11y_toggle", {key: e.target.dataset.a11y, on: e.target.checked});
  });
  // Sync UI to stored state
  var stored = load();
  document.addEventListener("DOMContentLoaded", function(){
    Object.keys(stored).forEach(function(k){ var c = document.querySelector("[data-a11y=\"" + k + "\"]"); if (c) c.checked = !!stored[k]; });
  });
})();